import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-032129e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "main",
  id: "simplified-auth"
}
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = { class: "mb-5 is-flex" }
const _hoisted_4 = { class: "is-flex" }
const _hoisted_5 = { class: "switch-centered" }
const _hoisted_6 = { class: "switch" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_9 = { class: "mr-1 switch-centered" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "switch-centered"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "icon mb-1" }
const _hoisted_14 = {
  key: 0,
  class: "ml-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: _ctx.useSimplifiedAuth,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchSimplifiedAuth && _ctx.switchSimplifiedAuth(...args))),
                ref: "checkbox"
              }, null, 8, _hoisted_7),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$gettext("Simplified authentication for this device")), 1)
        ]),
        (_ctx.name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$gettext("for account %{ name }", { name: _ctx.name })), 1))
          : _createCommentVNode("", true),
        (_ctx.useSimplifiedAuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "button is-pay has-text-weight-medium is-rounded action",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.unlock())),
                disabled: !_ctx.locked
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Edit")), 1),
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_fa_icon, {
                    class: "fa-md",
                    icon: _ctx.locked ? 'lock' : 'lock-open'
                  }, null, 8, ["icon"])
                ])
              ], 8, _hoisted_12)
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.locked && _ctx.useSimplifiedAuth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.handler.Ui.Pref.name), {
              handler: _ctx.handler,
              onSubmitConfig: _ctx.submitConfig
            }, null, 40, ["handler", "onSubmitConfig"]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}